import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import AppTrainingsRadarChart from '../../../../components/charts/app-trainings-radar-chart/AppTrainingsRadarChart';
import AppTrainingsSkillsRadarChart from '../../../../components/charts/app-trainings-skills-radar-chart/AppTrainingsSkillsRadarChart';
import { useFinishingTrainingExercises } from '../../../../hooks/useFinishingTrainingExercises';
import { ITraining } from '../../../../types/interfaces/training';
import { useStyles } from './FinishedTrainingStats.styles';

export interface IFinishedTrainingStatsProps {
  training: ITraining;
}

export default function FinishedTrainingStats({
  training,
}: IFinishedTrainingStatsProps) {
  const { t } = useTranslation();
  const theme = useTheme();

  const { classes } = useStyles(theme);
  const { exercises } = useFinishingTrainingExercises(training?.id);

  return (
    <Box className={classes.statsWrapper}>
      <Box className={classes.chartSection}>
        <Typography variant="label-text-md" marginBottom={1}>
          {t('statistics.loadDistribution')}
        </Typography>
        <Box className={classes.chartContainer}>
          <AppTrainingsRadarChart
            trainings={[training]}
            exercises={exercises}
          />
        </Box>
      </Box>

      <Box className={classes.chartSection}>
        <Typography variant="label-text-md" marginBottom={1}>
          {t('statistics.skillsDistribution')}
        </Typography>
        <Box className={classes.chartContainer}>
          <AppTrainingsSkillsRadarChart
            trainings={[training]}
            exercises={exercises}
          />
        </Box>
      </Box>
    </Box>
  );
}
